var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.494 3.201c.315-.294.73-.451 1.155-.451h4.702c.424 0 .84.157 1.155.451L17.75 5.3h2.203c1.496 0 2.796 1.145 2.796 2.663v10.624c0 1.518-1.3 2.663-2.796 2.663H4.045c-1.495 0-2.795-1.145-2.795-2.663V7.963c0-1.518 1.3-2.663 2.795-2.663H6.25l2.245-2.099zM9.65 4.25a.193.193 0 00-.13.047l-2.461 2.3a.75.75 0 01-.513.203h-2.5c-.763 0-1.295.567-1.295 1.163v10.624c0 .596.532 1.163 1.295 1.163h15.91c.763 0 1.295-.567 1.295-1.163V7.963c0-.596-.532-1.163-1.296-1.163h-2.5a.75.75 0 01-.512-.202l-2.46-2.301a.193.193 0 00-.131-.047H9.649z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.75a2.25 2.25 0 100 4.5 2.25 2.25 0 000-4.5zM8.25 13a3.75 3.75 0 117.5 0 3.75 3.75 0 01-7.5 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.75a.75.75 0 11-1.5 0 .75.75 0 011.5 0z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.942f1605dc369601f9df3455611f6153.svg";
export { ForwardRef as ReactComponent };